import { Heading } from '@spark-web/heading';
import { ArrowCircleRightIcon } from '@spark-web/icon';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { TextList } from '@spark-web/text-list';
import Exclamation from '../../../assets/exclamation.svg?react';
import { useApplicationData } from '../../provider';
import { DECLINED_APPLICATION } from '../../utils';

function DeclinedApplication() {
  const { quote, Identification: identification } = useApplicationData(['quote', 'Identification']);
  const { financialProduct } = quote || {};
  const { applicant } = identification || {};
  const { DECLINED_APPLICATION_REASON, DECLINED_MESSAGE } = DECLINED_APPLICATION;

  return (
    <Stack padding="large" gap="xxlarge" align="center">
      <Stack align="center" padding="large" gap="xxlarge">
        <Exclamation />
        <Heading level="1">{applicant?.firstName}, we're sorry</Heading>

        <Text align="center" size="standard" tone="muted">
          {DECLINED_MESSAGE.replace(':productName', financialProduct?.name ?? '')}
        </Text>
      </Stack>

      <TextList icon={<ArrowCircleRightIcon />} gap="xxlarge">
        {DECLINED_APPLICATION_REASON.map(({ title, message }) => (
          <Stack key={title} gap="xlarge" paddingBottom="medium">
            <Text size="standard" weight="semibold">
              {title}
            </Text>
            <Text size="small" tone="muted">
              {message}
            </Text>
          </Stack>
        ))}
      </TextList>
    </Stack>
  );
}

export default DeclinedApplication;
